export default {
  create_sale_page: 'Create sale page manually',
  sale_page_edited_by: 'Last edited by {user_name} ( {user_role} )',
  sale_page_generated_by: 'Generated by {user_name} ( {user_role} )',
  sale_page_more_info: '<span style="display: flex; column-gap: 10px; flex-wrap: wrap; justify-content: center; width: fit-content">' + '<span style="white-space: nowrap">Performance : </span>' + '<span style="white-space: nowrap"><span style="color: var(--app-info-color)">visits</span> {page_visits},</span>' + '<span style="white-space: nowrap"><span style="color: var(--app-success-color)">orders</span> {page_orders},</span>' + '<span style="white-space: nowrap"><span style="color: var(--app-fire-color)">conv. rate</span> {conversion_rate} %</span></span>',
  here_you_will_see: 'Here you can find all your created sales pages, you can create it manually or automatically.',
  page_not_up_to_date_alert: 'This page is not up to date, please save it or revert changes by clicking the reset button above.',
  buttons: {
    delete: 'Delete',
    edit: 'Edit',
    preview: 'Preview',
    duplicate: 'Duplicate',
    create_by_ai: 'Create Sale Page By AI',
    generate_by_ai: {
      title: 'Generate By AI',
      tooltip: 'Use Maxcom AI'
    }
  },
  preview: {
    select_variation_for_each_item: 'Please select the options you want for each item',
    select_variation_for_your_item: 'Please select the options you want for your item'
  },
  dialogs: {
    delete: {
      title: 'Delete Sale page',
      content: 'Pausing or deleting the sale page will impact the elements attached to it. Are you sure you want to proceed ?'
    },
    close: {
      title: 'Close Sale Page Form',
      content: 'Do you want to close this page without saving?'
    }
  },
  filter: {
    search: {
      placeholder: 'Filter sale pages ...'
    },
    domain: {
      option_all: 'All Stores'
    },
    offers: {
      option_all: 'All offers'
    },
    product: {
      option_all: 'All products'
    },
    country: {
      option_all: 'All countries'
    },
    users: {
      option_all: 'All users'
    },
    offer_payment_type: {
      option_all: 'All payment types'
    },
    sort_by: {
      text: 'Sort by',
      options: {
        old_to_new: 'Old to new',
        new_to_old: 'New to old',
        visits: 'Visits',
        orders: 'Orders'
      }
    },
    sort: {
      new_to_old: 'New to old',
      old_to_new: 'Old to new'
    }
  },
  product_sale_page_form: {
    upsell_fields: {
      four: {
        title: ''
      }
    }
  },
  sale_page_form: {
    toggle_form: 'Click here to create a sale page',
    no_page_selected: 'No page selected',
    no_offer_selected: 'No offer selected',
    no_product_selected: 'No product selected',
    sku: 'Sku: {sku}',
    modes: {
      desktop: 'Desktop',
      mobile: 'Mobile'
    },
    create_sale_page: {
      title: 'Create Sale page',
      subtitle: 'Create new sale page'
    },
    update_sale_page: {
      title: 'Update Sale page',
      subtitle: 'Update sale page'
    },
    steps: {
      one: {
        title: 'Step 1: Product info'
      },
      two: {
        title: 'Step 2: Sales page elements',
        sub_title: 'You can set language or add more product info, to help us create a better sale page with all the needed info about the product (like product size, colors, use cases, battery, materials,  and anything that your customers will want to know about the product)'
      },
      three: {
        title: 'Step 3: Checkout Sale options',
        subtitle: 'Edit offers name, quantity, and price'
      },
      four: {
        title: 'Step 4: Upsells and Cross-sells',
        subtitle: 'Thank you page upsells',
        subtitle_2: 'After upsells: Cross-sells for other offers',
        note: {
          note: 'Note',
          description: 'The Cross-sell offer list will be loaded if the sale page offer is already selected.'
        }
      },
      addons: {
        title: 'Page addons'
      },
      blocks: {
        title: 'page content'
      },
      tracking: {
        title: 'Page Pixels'
      }
    },
    fields: {
      status: {
        title: 'Page Status'
      },
      domain: {
        title: 'Store',
        placeholder: 'Select your store'
      },
      offer: {
        title: 'Sale page offer',
        placeholder: 'Select your offer'
      },
      product: {
        title: 'Sale page product',
        placeholder: 'Select your product'
      },
      inventory_country: {
        title: 'Inventory Country',
        placeholder: 'Select a country'
      },
      country: {
        title: 'Target Country',
        placeholder: 'No country'
      },
      country_select_type: {
        title: 'Sales Country',
        tooltip: 'The location of your target customers'
      },
      custom_currency: {
        display_currency: 'Sales Currency: {currency_code} ({currency_symbol})',
        edit_currency: 'Edit Currency',
        title: 'Sales Currency',
        placeholder: 'Choose a currency'
      },
      gender: {
        title: 'This product is for'
      },
      custom_currency_symbol: {
        title: 'Displayed Currency (don\'t put price here)',
        placeholder: 'Choose a currency Symbol'
      },
      shipping_countries: {
        title: 'Shipping Countries',
        placeholder: 'Select the shipping countries'
      },
      default_currency: {
        title: 'Default Currency'
      },
      url_name: {
        title: 'Sale page url name',
        placeholder: 'type your sale page url'
      },
      page_title: {
        title: 'page title',
        placeholder: 'type your sale page title'
      },
      description: {
        title: 'Sale page description',
        placeholder: 'type your sale page description'
      },
      language: {
        info: 'You can change language from store settings or enable multiple languages to change it here.'
      },
      checkout_options: {
        pricing: {
          title: 'Pricing',
          clarification: 'Setup Sale price for 1 piece, 2 pieces, 3 pieces, or bundle offers like Buy 1 Get 1 Free ...'
        },
        checkout_title: {
          title: 'Checkout Title'
        },
        checkout_form: {
          title: 'Checkout Form',
          custom_field_name: 'Custom Field Name',
          fields: {
            custom_fields: {
              title: 'FIELDS',
              buttons: {
                reset: 'Reset'
              }
            },
            rating: {
              count: 'Rating Count'
            }
          }
        },
        shipping: {
          title: 'Shipping'
        },
        reviews: {
          title: 'Reviews'
        }
      },
      product_video: {
        title: 'Product video (optional)',
        placeholder: 'example: https://youtube.com?v=xxxx'
      },
      title: {
        title: 'Checkout Title',
        placeholder: 'your checkout title',
        default: 'How many units you want ?'
      },
      subTitle: {
        title: 'Checkout Subtitle',
        placeholder: 'your checkout subtitle',
        default: 'Buy more to Save more !'
      },
      checkout_length: {
        title: 'Checkout Length'
      },
      add_block: {
        title: 'Add new content',
        button_title: 'Add to page'
      },
      short_product: {
        title: 'Short product name',
        placeholder: 'type your Short product name'
      },
      custom_data: {
        shipping: {
          delivery_text: {
            title: 'Delivery text',
            placeholder: 'Free delivery',
            default: 'Delivery date'
          },
          delivery_time: {
            title: 'Delivery date'
          }
        },
        reviews: {
          reviews_rating: {
            title: 'Reviews rating'
          },
          reviews_count: {
            title: 'Reviews count',
            placeholder: 'type the total number of ratings'
          },
          reviews_text: '{rating} ({count} Review(s))'
        }
      }
    },
    option_default_values: {
      options: {
        option_1: {
          option_name: 'Options 1',
          offer_name: 'Buy 1x Product name',
          discount: '{{dis}} off - {{up}}/piece'
        },
        option_2: {
          option_name: 'Options 2',
          offer_name: 'Buy 2 Get 1 Free',
          discount: '{{dis}} off - {{up}}/piece'
        },
        option_3: {
          option_name: 'Options 3',
          offer_name: 'Buy 3 Get 2 Free',
          discount: '{{dis}} off - {{up}}/piece'
        },
        option_4: {
          option_name: 'Options 4',
          offer_name: 'Buy 2',
          discount: '{{dis}} off - {{up}}/piece'
        },
        option_5: {
          option_name: 'Options 5',
          offer_name: 'Buy 3',
          discount: '{{dis}} off - {{up}}/piece'
        }
      },
      upsells: {
        upsell_1: {
          option_name: 'Options {n}',
          offer_name: 'Offer name',
          discount: 'Discount and unit price'
        }
      },
      cross_sells: {
        cross_sell_1: {
          option_name: 'Options {n}',
          offer_name: 'Offer name',
          discount: 'Discount and unit price'
        }
      }
    },
    option_fields: {
      option_name: {
        title: 'Quantity',
        translation: {
          option_1: '1 Piece',
          option_2: '2 Pieces',
          option_3: '3 Pieces',
          option_4: '4 Pieces',
          option_5: '5 Pieces'
        }
      },
      offer_name_and_discount: {
        title: 'Offer name / Discount text',
        placeholder: 'type your offer name and discount'
      },
      offer_name: {
        title: 'Offer name',
        placeholder: 'type your offer name'
      },
      discount: {
        title: 'Discount and unit price',
        placeholder: 'type the discount and/or unit price'
      },
      quantity: {
        title: 'Quantity'
      },
      normal_and_sale_price: {
        title: 'Sale / Old Price'
      },
      normal_price: {
        title: 'Normal Price'
      },
      sale_price: {
        title: 'Sale Price'
      }
    },
    upsell_fields: {
      option_name: {
        title: 'Option'
      },
      offer_name: {
        title: 'Offer name',
        placeholder: 'type your offer name'
      },
      offer_nick_name: {
        title: 'Offer nickname',
        placeholder: 'type your offer nickname'
      },
      offer_type: {
        title: 'Offer type',
        placeholder: 'Select your offer type'
      },
      discount: {
        title: 'Discount and unit price',
        placeholder: 'type the discount and/or unit price'
      },
      quantity: {
        title: 'Quantity'
      },
      normal_price: {
        title: 'Normal Price'
      },
      sale_price: {
        title: 'Sale Price'
      }
    },
    cross_sell_fields: {
      option_name: {
        title: 'Option'
      },
      offer_name: {
        title: 'Offer name',
        placeholder: 'Select an offer'
      },
      offer_nick_name: {
        title: 'Offer nickname',
        placeholder: 'type your offer nickname'
      },
      offer_type: {
        title: 'Offer type',
        placeholder: 'select the offer type'
      },
      discount: {
        title: 'Discount and unit price',
        placeholder: 'type the discount and/or unit price'
      },
      quantity: {
        title: 'Quantity'
      },
      normal_price: {
        title: 'Normal Price'
      },
      sale_price: {
        title: 'Sale Price'
      }
    },
    addon_fields: {
      background_color: {
        title: 'Background color.'
      },
      theme: {
        is_enabled: 'Choose a custom theme colors',
        primary_color: {
          title: 'Primary color'
        },
        secondary_color: {
          title: 'Secondary color'
        }
      },
      show_sale_page_navbar: {
        title: 'Show sale page navbar.'
      },
      show_sale_page_footer: {
        title: 'Show sale page footer.'
      },
      disable_selection_and_context_menu: {
        title: 'Disable text selection and mouse right click.'
      },
      include_in_home_and_product_page: {
        title: 'Show product on Home and Products page.'
      },
      sticky_buy_button: {
        title: 'Sticky BUY NOW Button.'
      },
      visible_button_price: {
        title: 'Make price visible beside BUY NOW Button.'
      },
      trust_badges_visibility: {
        title: 'After checkout Trust Badges.'
      },
      about_us_visibility: {
        title: 'After checkout About us.'
      },
      after_sale_faq_visibility: {
        title: 'After checkout Faqs.'
      },
      whatsapp_button: {
        title: 'Whatsapp Button.',
        country_id: {
          placeholder: 'Phone Code'
        },
        phone_number: {
          title: 'Phone Number'
        }
      },
      whatsapp_phone_number: {
        title: 'Phone number.'
      }
    },
    tracking: {
      buttons: {
        add_pixel: 'add pixel'
      }
    },
    buttons: {
      plan_incentives: '{tries} Pages created with AI!',
      plan_incentives_tries_left: '{tries} left',
      plan_incentives_button: 'Upgrade Now',
      create: 'Create sale page',
      delete: 'Delete page',
      save: 'Save page',
      preview: 'Preview page',
      duplicate: 'Duplicate page',
      cancel: 'Cancel',
      reset_form: 'Reset form',
      add_pixel: 'Add pixel'
    }
  }
};